import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ selectedDay }) => (
    <h3 className="nr-title">
        {selectedDay}: going, weather & non-runners
    </h3>
);

Header.propTypes = {
    selectedDay: PropTypes.string.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/js/nonRunners/nonRunners.header.jsx